//Import Mixpanel SDK
import mixpanel from 'mixpanel-browser';

const isEnabled = process.env.REACT_APP_MIXPANEL_ENABLED == 'true';
// Near entry of your product, init Mixpanel
if (isEnabled) {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_API!, {
    // debug: true,
    // track_pageview: true,
    persistence: 'localStorage',
  });
}

export function mixIdentify(userId: number, userData: any) {
  if (!isEnabled) return;

  mixpanel.identify(userId.toString());
  mixpanel.people.set(userData);
}

export function mixTrack(event: string, data?: any) {
  if (!isEnabled) return;

  mixpanel.track(event, data);
}
